<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-button @click="digAdd" icon="el-icon-plus" style="float: right;margin-right: 10px;">添加</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'name'
        label= '名称'>
      </el-table-column>
      <el-table-column
        prop= 'kkey'
        label= '角色关键字'>
      </el-table-column>
      <el-table-column
        prop= 'descr'
        label= '角色描述'>
      </el-table-column>
      <el-table-column
        prop= 'indexPage'
        label= '角色首页'>
      </el-table-column>

      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '160'>
        <template slot-scope='scope'>
          <el-button @click='queryBindPermisses(scope.row)' type='text' size='small' style="color: #209323">绑定菜单</el-button>
          <el-button @click='digEdit(scope.row)' type='text' size='small' style="color: #209323">编辑</el-button>
          <el-popover
            :ref="'delRef-'+scope.row.id"
            placement="right"
            width="160"
            trigger="click">
            <p>确定【编号:{{scope.row.id}}】删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delClose(scope.row)">取消</el-button>
              <el-button type="primary" size="mini" style="background-color: #209323;" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button slot="reference" type='text' size='small' style="color: #f56c6c">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible">
            <el-form :model="form">
        <el-form-item label="名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="角色关键字" :label-width="formLabelWidth">
          <el-input v-model="form.kkey" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="角色描述" :label-width="formLabelWidth">
          <el-input v-model="form.descr" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="角色首页" :label-width="formLabelWidth">
          <el-input v-model="form.indexPage" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm()" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="角色绑定菜单" :visible.sync="dialogBindVisible">
      <el-tree
        ref="tree"
        :data="permisses"
        show-checkbox
        node-key="id"
        :default-expanded-keys="bindPermisses"
        :default-checked-keys="bindPermisses"
        :props="defaultProps">
      </el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogBindVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindPermiss()" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
export default {
  data () {
    return {
      tableData: [],
      name: '',
      dialogFormVisible: false,
      dialogBindVisible: false,
      form: {
        id: null,
        addTime: null,
        upTime: null,
        name: null,
        kkey: null,
        descr: null,
        indexPage: null
      },
      formLabelWidth: '120px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      permisses: [],
      bindPermisses: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      curRole: {}
    }
  },
  created () {
    this.query()
    this.queryPermisses()
  },
  methods: {
    del (row) {
      let that = this
      console.log('del')
      document.body.click()
      let params = {
        id: row.id
      }
      requestService.post('/role/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    delClose (row) {
      console.log('delClose')
      document.body.click()
    },
    query () {
      let that = this
      requestService.get(`/role/listPage?current=${that.current}&pageSize=${that.pageSize}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    digEdit (row = {}) {
      this.form = {...row}
      this.dialogFormVisible = true
    },
    digAdd () {
      this.form = {}
      this.dialogFormVisible = true
    },
    submitForm () {
      let that = this
      that.dialogFormVisible = false
      console.log('add')
      let url = '/role/add'
      if (that.form.id) {
        url = '/role/edit'
      }
      requestService.post(url, that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
        that.query()
      })
    },
    queryPermisses () {
      let that = this
      requestService.get('/permission/list?dealTree=true', {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.permisses = res.data.body
      })
    },
    queryBindPermisses (row) {
      let that = this
      that.curRole = row
      requestService.get(`/permission/getPermissionListByRoleId?roleId=${row.id}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.bindPermisses = []
        for (let temp of res.data.body) {
          that.bindPermisses.push(temp.id)
        }
        that.$nextTick(() => {
          that.$refs.tree.setCheckedKeys(that.bindPermisses)
        })
        that.dialogBindVisible = true
      })
    },
    bindPermiss () {
      // console.log(this.$refs.tree.getCheckedNodes())
      // console.log(this.$refs.tree.getCheckedKeys())
      let that = this
      that.dialogBindVisible = false
      let permissionIdStr = ''
      for (let index in this.$refs.tree.getCheckedKeys()) {
        if (index < this.$refs.tree.getCheckedKeys().length - 1) {
          permissionIdStr = permissionIdStr + this.$refs.tree.getCheckedKeys()[index] + ','
        } else {
          permissionIdStr = permissionIdStr + this.$refs.tree.getCheckedKeys()[index]
        }
      }
      requestService.post('/role/bindPermissions', {roleId: that.curRole.id, permissionIds: permissionIdStr}, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/manage-components/role/Index.vue